module.exports = __webpack_public_path__ + "img/3@2x.a359f998.png";